import { connect } from 'react-redux';

import { clearFiltersAction } from '../../../../domain/state/filters/actions';
import { cancelFiltersAction } from '../../../../domain/state/mobile/actions';

import { Container } from './Container';

const mapDispatchToProps = (dispatch) => ({
  cancelFilters: () => dispatch(cancelFiltersAction()),
  clearFilters: () => dispatch(clearFiltersAction()),
});

const connector = connect(null, mapDispatchToProps);

export default connector(Container);
